<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="ag-grid-demo">
        <div class="flex flex-wrap justify-between items-center mb-5">
            <div class="mb-5 md:mb-0 mr-5 ag-grid-table-actions-left" style="display: flex">
                <div class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="year" @change="refresh" class="input-select vs-select--input" style="padding: 8.8px;">
                            <option :key="index" :value="item" v-for="(item,index) in years">{{ item }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div v-if="userInfo.type_id === 1" class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="country_id" @change="refresh" class="input-select vs-select--input">
                            <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <vs-checkbox v-model="markup">&nbsp;{{ $t('Markup') }}</vs-checkbox>
            </div>

            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <download-excel
                    class   = "btn btn-default"
                    :data   = "json_data"
                    :fields = "json_fields"
                    worksheet = "My Worksheet"
                    name = "distribution.xls">
                    <vs-button class="mb-4 md:mb-0">{{ $t('ExportToExcel') }}</vs-button>
                </download-excel>
            </div>
        </div>

        <div class="vx-row m-0">
            <div class="vx-col sm:w-5/12 w-full" style="font-weight: 600;font-size: .85rem;">SB Name</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">Q1</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">Q2</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">Q3</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">Q4</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">H1FY</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">H2FY</div>
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">FY</div>
        </div>

        <div v-for="(item) in items" id="category_tree">
            <vx-card class="mt-5">
                <div class="vx-row">
                    <div class="vx-col sm:w-5/12 w-full">
                        <span v-if="item.child && item.child.length > 0" class="float-left" style="margin-top: -9px;position:relative;width:35px;height: 24px;">
                            <span class="absolute" style="top:5px;" :id="'plus_'+item.id">
                                <feather-icon icon="PlusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('plus', item.id)"></feather-icon>
                            </span>
                            <span class="absolute" style="top:5px; display: none" :id="'minus_'+item.id">
                                <feather-icon icon="MinusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('minus', item.id)"></feather-icon>
                            </span>
                        </span>
                        {{ item.name }}
                    </div>
                    <div class="vx-col sm:w-1/12 w-full" :class="item.ms_q1 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.ms_q1 }}</div>
                    <div class="vx-col sm:w-1/12 w-full" :class="item.ms_q2 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.ms_q2 }}</div>
                    <div class="vx-col sm:w-1/12 w-full" :class="item.ms_q3 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.ms_q3 }}</div>
                    <div class="vx-col sm:w-1/12 w-full" :class="item.ms_q4 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.ms_q4 }}</div>
                    <div class="vx-col sm:w-1/12 w-full text-bold" :class="item.h1fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.h1fy }}</div>
                    <div class="vx-col sm:w-1/12 w-full text-bold" :class="item.h2fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.h2fy }}</div>
                    <div class="vx-col sm:w-1/12 w-full text-bold" :class="item.ms_fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item.ms_fy }}</div>
                </div>
            </vx-card>

            <div v-if="item.child" v-for="(item2) in item.child" class="ml-5 child" :class="'child_'+item.id">
                <vx-card class="mt-5">
                    <div class="vx-row">
                        <div class="vx-col sm:w-5/12 w-full">{{ item2.name }}</div>
                        <div class="vx-col sm:w-1/12 w-full" :class="item2.ms_q1 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.ms_q1 }}</div>
                        <div class="vx-col sm:w-1/12 w-full" :class="item2.ms_q2 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.ms_q2 }}</div>
                        <div class="vx-col sm:w-1/12 w-full" :class="item2.ms_q3 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.ms_q3 }}</div>
                        <div class="vx-col sm:w-1/12 w-full" :class="item2.ms_q4 >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.ms_q4 }}</div>
                        <div class="vx-col sm:w-1/12 w-full text-bold" :class="item2.h1fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.h1fy }}</div>
                        <div class="vx-col sm:w-1/12 w-full text-bold" :class="item2.h2fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.h2fy }}</div>
                        <div class="vx-col sm:w-1/12 w-full text-bold" :class="item2.ms_fy >= 1000 && !markupGlobal ? 'color-green' : ''">{{ item2.ms_fy }}</div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                userInfo: window.userInfo,
                countries: [],
                country_id: 0,
                markupGlobal : false,
                year: (new Date().getFullYear()),
                markup: false,
                items: [],
                itemsForExcel: [],

                json_fields: {
                    'SB Name': 'dealerName',
                    'User Name': 'userName',
                    'Q1': 'ms_q1_ex',
                    'Q2': 'ms_q2_ex',
                    'Q3': 'ms_q3_ex',
                    'Q4': 'ms_q4_ex',
                    'H1FY': 'h1fy_ex',
                    'H2FY': 'h2fy_ex',
                    'FY': 'ms_fy_ex',
                    /*'PRODUCT NAME': 'name',
                    'SKU': 'skus',
                    'Total price': 'total_price',
                    'Date': 'created_at',
                    'Keys': this.getKeys,*/
                },
                json_data: [],
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            }
        },

        watch: {
            markup(val) {
                this.markupGlobal = val;
                this.refresh();
            }
        },

        created() {
            this.$vs.loading();
            const thisIns = this;

            if (this.userInfo.type_id === 1) {
                axios.get(apiUrl + '/countries/getList?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.countries = data.data;
                            thisIns.countries.unshift({
                                id: 0,
                                name: "Global"
                            });
                            //thisIns.country_id = data.data[0].id;
                            thisIns.refresh();
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
            }
            else{
                thisIns.country_id = this.userInfo.country_id;
                thisIns.refresh();
            }

        },
        methods: {
            refresh(){
                this.$vs.loading();
                const thisIns = this;
                let markup = this.markup ? 1 : 0;

                axios.get(apiUrl+'/statistic/distribution?year='+this.year+'&country_id='+this.country_id+'&markup='+markup+'&token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.items = data.data;

                            thisIns.itemsForExcel = [];
                            data.data.forEach(function (item) {
                                item.dealerName = item.name;
                                item.userName = '';

                                item.ms_q1_ex = item.ms_q1;
                                item.ms_q2_ex = item.ms_q2;
                                item.ms_q3_ex = item.ms_q3;
                                item.ms_q4_ex = item.ms_q4;
                                item.h1fy_ex = item.h1fy;
                                item.h2fy_ex = item.h2fy;
                                item.ms_fy_ex = item.ms_fy;

                                thisIns.itemsForExcel.push(item);
                                if (item.child !== undefined) {
                                    item.child.forEach(function (item2) {

                                        item.ms_q1_ex -= item2.ms_q1;
                                        item.ms_q2_ex -= item2.ms_q2;
                                        item.ms_q3_ex -= item2.ms_q3;
                                        item.ms_q4_ex -= item2.ms_q4;
                                        item.h1fy_ex -= item2.h1fy;
                                        item.h2fy_ex -= item2.h2fy;
                                        item.ms_fy_ex -= item2.ms_fy;

                                        item2.ms_q1_ex = item2.ms_q1;
                                        item2.ms_q2_ex = item2.ms_q2;
                                        item2.ms_q3_ex = item2.ms_q3;
                                        item2.ms_q4_ex = item2.ms_q4;
                                        item2.h1fy_ex = item2.h1fy;
                                        item2.h2fy_ex = item2.h2fy;
                                        item2.ms_fy_ex = item2.ms_fy;

                                        item2.dealerName = item.name;
                                        item2.userName = item2.name;
                                        thisIns.itemsForExcel.push(item2);
                                    });
                                }
                            });

                            thisIns.json_data = thisIns.itemsForExcel;

                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            showContent(act, id){
                let plus = document.getElementById('plus_'+id);
                let minus = document.getElementById('minus_'+id);
                let child = document.getElementsByClassName('child_'+id);
                if (act === 'plus'){
                    minus.style.display = 'block';
                    plus.style.display = 'none';

                    for (let i = 0; i < child.length; i++) {
                        child[i].classList.add('active');
                    }
                }else{
                    plus.style.display = 'block';
                    minus.style.display = 'none';

                    for (let i = 0; i < child.length; i++) {
                        child[i].classList.remove('active');
                    }
                }
            },
        },

        computed : {
            years() {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2022}, (value, index) => 2023 + index)
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
        }
    }

</script>


<style lang="scss" scoped>

    #category_tree{
        .child{
            display: none;
            &.active{
                display: block;
            }
        }
        .text-bold{
            font-weight: bold;
        }
        .color-green{
            color: #43a047;
        }
    }


    .vs-table--tbody{
        border: 0 !important;

        .vs-table--tbody-table{
            .vs-table--thead th{
                border-bottom: 1px solid #e2e2e2;
            }
            .tr-values td{
                border-bottom: 1px solid #e2e2e2;
            }
        }

        .text-bold{
            font-weight: bold;
        }
        .color-green{
            color: #43a047;
        }
    }
</style>
